export default __webpack_public_path__ + "static/media/streamer_avatar12.99ddf4f3.png";